import { Box, Button, Grid, Typography, withStyles } from "@material-ui/core"

import React from "react"
import { Link } from "react-router-dom"
import icon_whatsapp from "../../../assets/images/icon_whatsapp.svg"

const style = (theme) => ({
	requestCallText: {
		color: "#ff6840",
		textTransform: "none",
		fontSize: 18,
		fontWeight: 600,
	},
	tertiaryButton: {
		textDecoration: "underline",
		textDecorationColor: "#ff6840", // specify the color of the underline
		paddingBottom: theme.spacing(1),
	},
	viewDetailText: {
		color: "#fff",
		textTransform: "none",
		fontSize: 14,
		fontWeight: 600,
	},
	whatsappButton: {
		backgroundColor: "transparent",
		hover: "none",
		padding: 0,
		paddingRight: theme.spacing(1),
		margin: 0,
		minWidth: "auto", // Add this line to make the button size as per the image
	},
	whatsappImage: {
		width: "32px",
		height: "32px",
	},
})

const Actions = (props) => {
	const { classes, packageData } = props

	return (
		<React.Fragment>
			<Grid item>
				<Grid container item direction="column" justifyContent="flex-end" alignItems="flex-end">
					<Button variant="text" className={classes.tertiaryButton} onClick={props.onRequestCallClick}>
						<Typography variant="body2" className={classes.requestCallText}>
							Request call
						</Typography>
					</Button>
					<Grid container item direction="row">
						<Button className={classes.whatsappButton} onClick={props.onWhatsAppClick}>
							<img src={icon_whatsapp} alt="WhatsApp" className={classes.whatsappImage} />
						</Button>
						<Button variant="contained" color="primary" component={Link} to={`/packagedetails/${packageData.slug}`} onClick={props.onPackageDetailClick}>
							<Typography variant="body2" className={classes.viewDetailText}>
								View Details
							</Typography>
						</Button>
					</Grid>
				</Grid>
			</Grid>
		</React.Fragment>
	)
}

export default withStyles(style)(Actions)
